import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";

const userSearchStyle = {
  ...customInputStyle,
  foundUserBox: {
    borderRadius: "0 0 5px 5px",
    backgroundColor: "#f1f1f1",
    position: "relative",
    minHeight: "50px",
    transition: "all 0.1s",
    paddingLeft: 50,
    lineHeight: "15px",
    "&:empty": {
      minHeight: 0
    }
  },
  foundUserName: {
    margin: 0,
    marginTop: 5,
    fontSize: 16
  },
  foundUserLocation: {
    margin: 0,
    fontSize: "12px",
    color: "#5a5a5a"
  },
  foundUserTypes: {
    fontSize: "9px",
    color: "#5a5a5a",
    margin: "2px 0",
    marginBottom: 8
  },
  notFoundUserLabel: {
    fontSize: "12px",
    color: "#5a5a5a",
    lineHeight: "50px"
  },
  foundUserLoading: {
    position: "absolute",
    top: "10px",
    left: "10px",
    "&>svg": {
      color: "gray"
    }
  },
  foundUserIcon: {
    position: "absolute",
    left: "10px",
    top: "10px",
    fontSize: "30px",
    color: "green!important"
  },
  notFoundUserIcon: {
    position: "absolute",
    left: "10px",
    top: "10px",
    fontSize: "30px",
    color: "red!important"
  },
  labelRoot: {
    ...customInputStyle.labelRoot,
    "& + div": {
      marginTop: "0px"
    }
  },
};

console.log(userSearchStyle);

export default userSearchStyle;